import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01ae0c6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inside-shuttle-map-container" }
const _hoisted_2 = { class: "segmented-control" }
const _hoisted_3 = { class: "map-content-area" }
const _hoisted_4 = {
  ref: "mapContainer",
  id: "map"
}
const _hoisted_5 = { class: "line-select-container" }
const _hoisted_6 = { class: "upper-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "사내셔틀" }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode($setup["SegmentedControl"], {
            ref: "segmentedControl",
            segments: $setup.segments,
            initialIndex: $setup.selectedSegmentIndex,
            onOnChangedSegmentIndex: $setup.onChangedSegmentIndex
          }, null, 8 /* PROPS */, ["segments", "initialIndex"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, null, 512 /* NEED_PATCH */),
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["CustomSelect"], {
              class: "select-container",
              filter: $setup.lineFilter,
              onOnSelectOption: $setup.handleSelectOption
            }, null, 8 /* PROPS */, ["filter"])
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createVNode($setup["MapZoomLevelSetter"], {
              class: "zoom-level",
              zoomLevel: $setup.zoomLevel,
              maxZoomLevel: $setup.MAX_ZOOM_LEVEL,
              minZoomLevel: $setup.MIN_ZOOM_LEVEL,
              onZoomIn: _cache[0] || (_cache[0] = ($event: any) => ($setup.increaseZoomLevel($setup.map))),
              onZoomOut: _cache[1] || (_cache[1] = ($event: any) => ($setup.decreaseZoomLevel($setup.map)))
            }, null, 8 /* PROPS */, ["zoomLevel"]),
            _createElementVNode("button", {
              class: "gps-btn-wrapper",
              type: "button",
              "aria-label": "내 위치로 이동",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (
              $setup.moveMapToCenter(
                $setup.currentLocation?.latitude,
                $setup.currentLocation?.longitude
              )
            ))
            }, [
              _createVNode($setup["InlineSvg"], {
                class: "img-gps-btn",
                src: require('@/assets/icons/gps.svg'),
                alt: "내 위치로 이동",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, ["src"])
            ]),
            _createElementVNode("button", {
              ref: "refreshButton",
              class: _normalizeClass(["refresh-btn-wrapper", { rotate: $setup.isRotating }]),
              type: "button",
              "aria-label": "새로 고침",
              onClick: $setup.onClickRefreshBtn
            }, [
              _createVNode($setup["InlineSvg"], {
                class: "img-refresh-btn",
                src: require('@/assets/icons/rotate.svg'),
                alt: "새로 고침",
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, ["src"])
            ], 2 /* CLASS */)
          ])
        ])
      ]),
      ($setup.shouldShowNotAvailableAlert)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 0,
            title: "안내",
            okButtonTitle: "확인",
            onOnClickOkButton: $setup.handleClickOkBtn
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString($setup.unavailableCampusName) + " 내에서만 조회 가능합니다", 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}